import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { istanbulDayString, t } from '@aquabox/shared';
import { Kpi } from '../../components/Kpi';
import { api } from '../../api/client';
import { useLiveTrips } from '../../api/queries';
import { OPEN_TRIP_STATUSES } from '../../lib/stale-trip';
import type { Dashboard } from '../../api/types';

/**
 * "Bugün bir bakışta" şeridi: sipariş · damacana · açık sefer · bekleyen onay. Hepsi canlı
 * (dashboard 30 sn, seferler 15 sn). Ciro bunun hemen altındaki `KpiCards`'ta durur.
 * Damacana sayısı günlük rapor ucundan (`/api/reports/daily`, `jugs.total`) gelir (sunucu toplar, panel hesaplamaz).
 */
export function TodaySummary({ today }: { today: Dashboard['today'] }) {
  const navigate = useNavigate();
  const day = istanbulDayString(new Date());
  const jugs = useQuery({
    queryKey: ['report', `day=${day}`],
    queryFn: () => api.get<{ jugs: { total: number } }>(`/api/reports/daily?day=${day}`),
    refetchInterval: 60_000,
  });
  const trips = useLiveTrips();
  const dash = t('dashboard.kpi.placeholder');
  const openTrips = trips.data
    ? trips.data.items.filter((trip) => OPEN_TRIP_STATUSES.includes(trip.status)).length
    : null;
  return (
    <section className="kpi-grid" aria-label={t('overview.summaryTitle')}>
      <Kpi
        label={t('overview.summaryOrders')}
        value={today.orders}
        onClick={() => void navigate('/siparisler')}
      />
      <Kpi
        label={t('overview.summaryJugs')}
        value={jugs.data ? jugs.data.jugs.total : dash}
        onClick={() => void navigate('/raporlar')}
      />
      <Kpi
        label={t('overview.summaryOpenTrips')}
        value={openTrips ?? dash}
        onClick={() => void navigate('/seferler')}
      />
      <Kpi
        label={t('overview.summaryApprovals')}
        value={today.approvalTotal}
        accent={today.approvalTotal > 0 ? 'warning' : undefined}
        onClick={() => void navigate('/onaylar')}
      />
    </section>
  );
}
